import { gql } from 'graphql-request';
import { getContentStackLang } from 'src/utils';
import { graphQLClient, ILocaleReq } from '../..';

interface ICategory {
  key: string;
  title: string;
}

interface IMenus {
  title: string;
  url: string;
  categoryConnection: {
    edges: Array<{
      node: ICategory;
    }>;
  };
}

const pageHeaderFooter = ({ locale }: ILocaleReq) => {
  // contentStack 都是用的全小写，这里需要转换
  const lowerLocale = getContentStackLang(locale);
  return gql`
  query PageHeaderFooter {
    page_header_footer(uid: "blt783ddef074639c1a", locale: "${lowerLocale}") {
      title
      header_menu {
        title
        url
        categoryConnection {
          edges {
            node {
              ... on MetaCategory {
                key
              }
            }
          }
        }
      }
      bannerConnection {
        edges {
          node {
            url
          }
        }
      }
    }
  }
`;
};

export interface IHeaderFooterEntry {
  title: string;
  bannerConnection: {
    edges: Array<{
      node: {
        url: string;
      };
    }>;
  };
  header_menu: Array<IMenus>;
}

export const getHeaderFooterPageEntry = async (
  req: ILocaleReq
): Promise<IHeaderFooterEntry> => {
  const data = await graphQLClient.request(pageHeaderFooter(req));
  return data?.page_header_footer;
};
